import { Address } from "./address.tsx";

export class Shipping {
    private address: Address | null | undefined;
    private carrier: string | null | undefined;
    private phone: string | null | undefined;
    private tracking_number: string | null | undefined;

    constructor(address: Address | null | undefined, carrier: string | null | undefined, phone: string | null | undefined, tracking_number: string | null | undefined) {
        this.setAddress(address);
        this.setCarrier(carrier);
        this.setPhone(phone);
        this.setTrackingNumber(tracking_number);
    }

    static fromJson(json:any) {
        return new Shipping(json.address !== null && json.address !== undefined ? Address.fromJson(json.address) : null, json.carrier, json.phone, json.tracking_number);
    }

    setAddress(newAddress:Address | null | undefined) {
        this.address = newAddress;
    }
    setCarrier(newCarrier:string | null | undefined) {
        this.carrier = newCarrier;
    }
    setPhone(newPhone:string | null | undefined) {
        this.phone = newPhone;
    }
    setTrackingNumber(newTrackingNumber:string | null | undefined) {
        this.tracking_number = newTrackingNumber;
    }

    getAddress() {
        return this.address;
    }
    getCarrier() {
        return this.carrier;
    }
    getPhone() {
        return this.phone;
    }
    getTrackingNumber() {
        return this.tracking_number;
    }
}